// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.text-main {
  padding-bottom: 20px;
}

span.text-label-input {
  width: 50%;
}

.tooltip-input {
  width: 50%;
}

.display-inline-label {
  display: inline;
}

.checkout-body .checkout-subheader {
  margin-bottom: 30px;
  margin-top: 30px;
}
.checkout-body .btn-next {
  margin: 20px 0;
}
.checkout-body .btn-next .disabled {
  color: #767676;
}
.checkout-body .tiny-accordion {
  width: 100%;
}
.checkout-body .checkout-footer {
  border-top: 1px solid #d2d2d2;
  margin-bottom: 60px;
  margin-top: 30px;
}
.checkout-body .checkout-footer .btn-top {
  margin-top: 30px;
}
.checkout-body .panel {
  display: block;
}
.checkout-body .showpanel {
  display: none !important;
}
.checkout-body .field-group {
  display: block;
  margin-top: 4px;
  position: relative;
}
.checkout-body .extDevNwt {
  margin-bottom: 10px;
}
.checkout-body .toggle-header {
  border-color: white;
  border-top: 1px solid #d2d2d2;
  color: hsl(204.9, 94.4%, 35.1%);
  cursor: pointer;
  display: block;
  font-size: 20px;
  line-height: 2.2rem;
  padding: 16px 55px 20px 0;
  position: relative;
}
.checkout-body .toggle-header .icon-accordion-plus, .checkout-body .toggle-header .icon-accordion-minus {
  display: inline-block;
  font-size: 20px;
  margin-top: -10px;
  padding: 0;
  position: absolute;
  right: 15px;
  top: 50%;
  vertical-align: middle;
}
.checkout-body .content-margin {
  margin-left: 0;
}
.checkout-body .text-danger {
  margin-bottom: 10px;
}

.marleft-20 {
  margin-left: 15px;
}

.infoLink h3 {
  font: 24px Omnes-ATT-W02-Medium;
  margin-top: 20px;
}
.infoLink ol {
  list-style-type: decimal;
  padding-left: 30px;
}
.infoLink ol li {
  list-style-type: decimal;
  padding: 5px 0px;
}
.infoLink ul {
  list-style-type: none;
  padding-left: 20px;
}
.infoLink ul li {
  list-style-type: none;
}

@media (max-width: 1024px) {
  .checkout-body .checkout-footer {
    border-bottom: 0 !important;
    margin-bottom: 30px;
    margin-top: 30px;
  }
  .checkout-body .checkout-footer .btn-top {
    margin-top: 20px;
  }
  .checkout-body .checkout-subheader {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .checkout-body .btn-next {
    width: 100%;
  }
  .tiny-accordion {
    margin-left: 0;
    width: 100%;
  }
  .button-group {
    display: block;
    text-align: center;
  }
  .button-group .btn {
    display: block;
    float: none;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/lib/ng2-sapmp/src/ui-components/form-builder/form-builder.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAjJA;EACE,oBAAA;AAmJF;;AA/IA;EACE,UAAA;AAkJF;;AA/IA;EACE,UAAA;AAkJF;;AA/IA;EACE,eAAA;AAkJF;;AA5IE;EACE,mBAAA;EACA,gBAAA;AA+IJ;AA5IE;EACE,cAAA;AA8IJ;AA3IE;EACE,cAAA;AA6IJ;AA1IE;EACE,WAAA;AA4IJ;AAzIE;EACE,6BAAA;EACA,mBAAA;EACA,gBAAA;AA2IJ;AAzII;EACE,gBAAA;AA2IN;AAvIE;EACE,cAAA;AAyIJ;AAtIE;EACE,wBAAA;AAwIJ;AArIE;EACE,cAAA;EACA,eAAA;EACA,kBAAA;AAuIJ;AApIE;EACE,mBAAA;AAsIJ;AApIE;EACE,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAsIJ;AApII;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AAsIN;AAlIE;EACE,cAAA;AAoIJ;AAjIE;EACE,mBAAA;AAmIJ;;AA/HA;EACE,iBAAA;AAkIF;;AA9HE;EACE,+BAAA;EACA,gBAAA;AAiIJ;AA/HE;EACE,wBAAA;EACA,kBAAA;AAiIJ;AAhII;EACE,wBAAA;EACA,gBAAA;AAkIN;AA/HE;EACE,qBAAA;EACA,kBAAA;AAiIJ;AAhII;EACE,qBAAA;AAkIN;;AFjOI;EEuGA;IACE,2BAAA;IACA,mBAAA;IACA,gBAAA;EA8HJ;EA5HI;IACE,gBAAA;EA8HN;EA1HE;IACE,mBAAA;IACA,gBAAA;EA4HJ;EAzHE;IACE,WAAA;EA2HJ;EAvHA;IAEE,cAAA;IACA,WAAA;EAwHF;EArHA;IACE,cAAA;IACA,kBAAA;EAuHF;EArHE;IACE,cAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;EAuHJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../assets/style/mixinfunction';\n\n.text-main {\n  padding-bottom: 20px;\n}\n\n// changes for tooltip\nspan.text-label-input {\n  width: 50%;\n}\n\n.tooltip-input {\n  width: 50%;\n}\n\n.display-inline-label {\n  display: inline;\n}\n\n\n.checkout-body {\n\n  .checkout-subheader {\n    margin-bottom: 30px;\n    margin-top: 30px;\n  }\n\n  .btn-next {\n    margin: 20px 0;\n  }\n\n  .btn-next .disabled {\n    color: color(inverse, light);\n  }\n\n  .tiny-accordion {\n    width: 100%;\n  }\n\n  .checkout-footer {\n    border-top: 1px solid color(default, dark);\n    margin-bottom: 60px;\n    margin-top: 30px;\n\n    .btn-top {\n      margin-top: 30px;\n    }\n  }\n\n  .panel {\n    display: block;\n  }\n\n  .showpanel {\n    display: none !important;\n  }\n\n  .field-group {\n    display: block;\n    margin-top: 4px;\n    position: relative;\n  }\n\n  .extDevNwt {\n    margin-bottom: 10px;\n  }\n  .toggle-header {\n    border-color: color(default, light);\n    border-top: 1px solid color(default, dark);\n    color: color(secondary, base);\n    cursor: pointer;\n    display: block;\n    font-size: 20px;\n    line-height: 2.2rem;\n    padding: 16px 55px 20px 0;\n    position: relative;\n\n    .icon-accordion-plus, .icon-accordion-minus {\n      display: inline-block;\n      font-size: 20px;\n      margin-top: -10px;\n      padding: 0;\n      position: absolute;\n      right: 15px;\n      top: 50%;\n      vertical-align: middle;\n    }\n  }\n\n  .content-margin {\n    margin-left: 0;\n  }\n\n  .text-danger {\n    margin-bottom: 10px;\n  }\n}\n\n.marleft-20 {\n  margin-left: 15px;\n}\n\n.infoLink{\n  h3 {\n    font: 24px Omnes-ATT-W02-Medium;\n    margin-top: 20px;\n  }\n  ol {\n    list-style-type: decimal;\n    padding-left: 30px;\n    li{\n      list-style-type: decimal;\n      padding: 5px 0px;\n    }\n  }\n  ul {\n    list-style-type: none;\n    padding-left: 20px;\n    li {\n      list-style-type: none; \n    }\n  }\n}\n\n@include respond-to(small) {\n  .checkout-body {\n\n    .checkout-footer {\n      border-bottom: 0 !important;\n      margin-bottom: 30px;\n      margin-top: 30px;\n\n      .btn-top {\n        margin-top: 20px;\n    }\n    }\n\n    .checkout-subheader {\n      margin-bottom: 20px;\n      margin-top: 20px;\n  }\n\n    .btn-next {\n      width: 100%;\n    }\n  }\n\n  .tiny-accordion {\n\n    margin-left: 0;\n    width: 100%;\n  }\n\n  .button-group {\n    display: block;\n    text-align: center;\n\n    .btn {\n      display: block;\n      float: none;\n      margin-left: auto;\n      margin-right: auto;\n      width: 100%;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
